import React from 'react';

const Input = () => {
	return (
		<label className="vtex-input w-100" data-dashlane-label="true">
			<span className="vtex-input__label db mb3 w-100 c-on-base t-small">CEP</span>
			<div
				className="
        vtex-input-prefix__group
        flex flex-row
        items-stretch
        overflow-hidden
        br2
        bw1
        b--solid b--muted-4
        hover-b--muted-3
        h-regular
      "
			>
				<input
					className="
          vtex-address-form-4-x-input
          ma0
          border-box
          vtex-address-form-4-x-hideDecorators
          vtex-address-form-4-x-noAppearance
          br2
          br-0 br--left
          w-100
          bn
          outline-0
          bg-base
          c-on-base
          b--muted-4
          hover-b--muted-3
          t-body
          pl5
        "
					name="postalCode"
					type="tel"
					value=""
					data-dashlane-rid="fb88b7ba43675e90"
					data-kwimpalastatus="alive"
					data-kwimpalaid="1639108856201-0"
					data-form-type="address,zip"
				/>
				<span
					className="
          c-muted-2
          fw5
          flex
          items-center
          t-body
          bg-base
          vtex-input__suffix
          br2
          bl-0
          br--right
          pr5
          pl3
        "
				></span>
			</div>
		</label>
	);
};

export default Input;
